"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.shape({
      pwdTitle: _propTypes.default.string,
      pwdSubTitle: _propTypes.default.string,
      textlabel: _propTypes.default.string,
      pwdNote: _propTypes.default.string,
      pwdNoteTitle: _propTypes.default.string,
      pwdFooter: _propTypes.default.string
    }),
    initialValues: _propTypes.default.shape({
      pwdId: _propTypes.default.string
    }),
    formRef: _propTypes.default.object,
    onSubmit: _propTypes.default.func,
    handleField: _propTypes.default.func,
    errorCallback: _propTypes.default.func,
    hideForm: _propTypes.default.bool,
    customMargin: _propTypes.default.string,
    pwdIdMaxChar: _propTypes.default.number,
    onFocusHandler: _propTypes.default.func
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    onSubmit: function onSubmit() {},
    handleField: function handleField() {},
    errorCallback: function errorCallback() {},
    initialValues: _constant2.INITIAL_VALUES,
    hideForm: false,
    pwdIdMaxChar: 35,
    onFocusHandler: function onFocusHandler() {}
  }
};
exports.default = _default;